import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "./UserContext";
import "./NavBar.css";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false); // State to manage the toggle of the menu
  const navigate = useNavigate();

  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [forumsMenuOpen, setForumsMenuOpen] = useState(false);
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
  document.body.classList.remove('menu-open');
  setIsOpen(false);
}, []);


  const isMobileDevice = () => {
    return (/(android|iphone|ipad|ipod|blackberry|mini|windows\sce|palm)/i.test(navigator.userAgent.toLowerCase()));
  };

  
const handleLogout = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  setUser(null);
  navigate("/");
};

const forumComingSoon = (forumName) => {
  alert(`${forumName} forum coming soon!`);
};

const goToProfileView = () => {
  if (!user) {
    navigate("/login");
    return;
  }
  navigate(`/artist/${user.username}`);
};

const goToProfileEdit = () => {
  if (!user) {
    navigate("/login");
    return;
  }
  navigate(`/artist/${user.username}?view=edit`);
};

  const forumsAlert = () => {
    alert("Coming Soon!");
  };

  const echoAlert = () => {
    alert("Coming Soon!");
  };

  const songAlert = () => {
    alert("To upload songs, first login/register, and then go to edit my profile");
  };

return (
  <>
    <div className="navfirstparent">
      <nav style={{ backgroundColor: "#333", color: "black", size: "20px" }}>
        {isMobileDevice() && (
          <>
            {isOpen && (
              <div className="menu-content">
                <button id="loginBtn" className="nav-button" onClick={() => navigate('/login')}>Log in</button>
                <div id="profileDropdown" className="nav-dropdown">
                  <button
                    id="profileBtn"
                    className="nav-button"
                    onClick={() => setProfileMenuOpen(prev => !prev)}
                  >
                    Profile Stuff
                  </button>
                  {profileMenuOpen && (
                    <div className="nav-submenu">
                      <button className="nav-submenu-button" onClick={goToProfileView}>View Your Profile</button>
                      <button className="nav-submenu-button" onClick={goToProfileEdit}>Edit Your Profile</button>
                      {user && (
                        <button className="nav-submenu-button" onClick={handleLogout}>Log Out</button>
                      )}
                    </div>
                  )}
                </div>
                <button id="uploadBtn" className="nav-button" onClick={songAlert}>Upload Songs</button>
                <button id="echoBtn" className="nav-button" onClick={echoAlert}>Forums</button>
                <button id="registerBtn" className="nav-button" onClick={() => navigate('/register')}>Register (free)</button>
              </div>
            )}
          </>
        )}

        {!isMobileDevice() && (
          <>
            <div className="nav-button hamburger"> </div>
            <div className="menu-content">
              <div className="nav-left">
                <div
                  id="profileDropdown"
                  className="nav-dropdown nav-border-btn"
                  onMouseEnter={() => setProfileMenuOpen(true)}
                  onMouseLeave={() => setProfileMenuOpen(false)}
                >
                  <button
                    id="profileBtn"
                    className="nav-button nav-border-btn"
                    onClick={() => setProfileMenuOpen(prev => !prev)}
                  >
                    Profile Stuff
                  </button>
                  {profileMenuOpen && (
                    <div className="nav-submenu nav-border-btn">
                      <button className="nav-submenu-button" onClick={goToProfileView}>View Your Profile</button>
                      <button className="nav-submenu-button" onClick={goToProfileEdit}>Edit Your Profile</button>
                      {user && (
                        <button className="nav-submenu-button" onClick={handleLogout}>Log Out</button>
                      )}
                    </div>
                  )}
                </div>

                <button id="uploadBtn" className="nav-button nav-border-btn" onClick={songAlert}>
                  Upload Songs
                </button>

                <div
                  id="forumsDropdown"
                  className="nav-dropdown"
                  onMouseEnter={() => setForumsMenuOpen(true)}
                  onMouseLeave={() => setForumsMenuOpen(false)}
                >
                  <button
                    id="echoBtn"
                    className="nav-button nav-border-btn"
                    onClick={() => setForumsMenuOpen(prev => !prev)}
                  >
                    Forums
                  </button>
                  {forumsMenuOpen && (
                    <div className="nav-submenu">
                      <button className="nav-submenu-button" onClick={() => forumComingSoon("Looking for a Band")}>Looking for a Band</button>
                      <button className="nav-submenu-button" onClick={() => forumComingSoon("Shows & Venues")}>Shows & Venues</button>
                      <button className="nav-submenu-button" onClick={() => forumComingSoon("Records & Deep Cuts")}>Records & Deep Cuts</button>
                      <button className="nav-submenu-button" onClick={() => forumComingSoon("Gear & Recording")}>Gear & Recording</button>
                    </div>
                  )}
                </div>

                <button
                  className="nav-button nav-border-btn"
                  onClick={() => {
                    localStorage.setItem('openShows', 'true');
                    window.dispatchEvent(new Event('openShowsDrawer'));
                  }}
                >
                  Shows
                </button>

                <button
                  className="nav-button nav-border-btn"
                  onClick={() => window.dispatchEvent(new Event('openAboutDrawer'))}
                >
                  About
                </button>
              </div>

              <div className="nav-auth">
                <span className="nav-terminal">
                  &gt; echo $USER: <span className="nav-terminal-value">
                    {user ? user.username : "not_logged_in"}
                  </span>
                  <span className="nav-terminal-cursor">█</span>
                </span>
                {user ? (
                  <button className="nav-button nav-auth-btn" onClick={handleLogout}>Log Out</button>
                ) : (
                  <>
                    <button className="nav-button nav-auth-btn" onClick={() => navigate('/login')}>Log In</button>
                    <button className="nav-button nav-auth-btn" onClick={() => navigate('/register')}>Register (free)</button>
                  </>
                )}
              </div>
            </div>
            <div className="horizontal-line"></div>
          </>
        )}
      </nav>
    </div>

    {/* HAMBURGER OUTSIDE navfirstparent */}
    {isMobileDevice() && (
      <button className="nav-button hamburger" onClick={() => {
        setIsOpen(!isOpen);
        document.body.classList.toggle('menu-open');
      }}>
        <svg width="200" height="46" viewBox="0 0 35 40">
          <rect x="2" y="0" width="6" height="40" rx="3" fill="black"/>
          <rect x="0" y={isOpen ? "2" : "28"} width="10" height="6" rx="2" fill="#FF8C00"
            style={{ transition: "y 0.3s ease" }}/>
          <rect x="14" y="0" width="6" height="40" rx="3" fill="black"/>
          <rect x="12" y={isOpen ? "2" : "8"} width="10" height="6" rx="2" fill="#FF8C00"
            style={{ transition: "y 0.3s ease" }}/>
          <rect x="26" y="0" width="6" height="40" rx="3" fill="black"/>
          <rect x="24" y={isOpen ? "2" : "18"} width="10" height="6" rx="2" fill="#FF8C00"
            style={{ transition: "y 0.3s ease" }}/>
        </svg>
      </button>
    )}
  </>
);





};

export default NavBar;
